export default "https://cdn-web.disco.co/connect-slack-thumbnail-photo-c22f409c846be7eff7bddce29014f371.png";